import { planningAPI } from "../../axios";

export const actions = {

    // Indicator Item
    CreateItemTag(context, data){
        return planningAPI.post("IndicatorItemTag/Tag/Add", data);
    },
    GetSingleItemTag(context, data){
        return planningAPI.get(`IndicatorItemTag/Tag/Get/${data}`);
    },
    GetAllItemTag(context, data){
        return planningAPI.get(`IndicatorItemTag/Tag/All`);
    },
    UpdateItemTag(context, data){
        return planningAPI.put(`IndicatorItemTag/Tag/Update/${data.id}`, data);
    },
    DeleteItemTag(context, data){
        return planningAPI.delete(`IndicatorItemTag/Tag/Remove/${data}`);
    },
    AddTagToIndicatorItem(context, data){
        return planningAPI.post(`IndicatorItemTag/IndicatorItem/Add`, data);
    },
    GetTagFromIndicatorItem(context, data){
        return planningAPI.get(`IndicatorItemTag/IndicatorItem/${data}`);
    },
    RemoveTagFromIndicatorItem(context, data){
        return planningAPI.delete(`IndicatorItemTag/IndicatorItem/Remove/${data}`);
    },
    UpdateSorting(context, data){
        return planningAPI.put(`IndicatorItemTag/Tag/Update/Sorting`, data);
    },
}